export default __webpack_public_path__ + "static/media/safety.1b318303.png";